import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    tipoEnfermedad: [],
  },

  getters: {
    getTipoEnfermedad: (state) => state.tipoEnfermedad,
  },

  mutations: {
    SET_TIPO_ENFERMEDAD(state, tipoEnfermedad) {
      state.tipoEnfermedad = tipoEnfermedad;
    },
  },

  actions: {
    async fetchTipoEnfermedad({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catTipoEnfermedad')
        .then((response) => {
          commit('SET_TIPO_ENFERMEDAD', response.data.data);
        });
    },
  },
};
